import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { ALERT_CATEGORY_MAP, ALERT_TYPES } from '../../../shared/models/alert.model';
import { AlertLog, AlertRecipient } from '../../../shared/services/lockdown-user.service';

@Component({
  selector: 'app-alert-recipients-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './alert-recipients-modal.component.html'
})
export class AlertRecipientsModalComponent {
  @Input() alert!: AlertLog;
  @Input() recipients: AlertRecipient[] = [];
  @Input() loading = false;
  @Output() closed = new EventEmitter<void>();

  icons = Icons;

  alertTypeName(typeId: number): string {
    return ALERT_TYPES[typeId] ?? 'Unknown';
  }

  alertTypeClass(typeId: number): string {
    const category = ALERT_CATEGORY_MAP[typeId] ?? 'lockdown';
    switch (category) {
      case 'lockdown':       return 'bg-red-100 text-red-600';
      case 'fire':           return 'bg-orange-100 text-orange-600';
      case 'police':         return 'bg-blue-100 text-blue-600';
      case 'medical':        return 'bg-green-100 text-green-600';
      case 'administrative': return 'bg-purple-100 text-purple-600';
      default:               return 'bg-gray-100 text-gray-600';
    }
  }

  recipientTypeLabel(type: number): string {
    return type === 1 ? 'User' : 'Contact';
  }
}
